import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Pages.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    website: '' // honeypot field
  });
  const [status, setStatus] = useState({
    submitted: false,
    submitting: false,
    error: null
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Check honeypot field
    if (formData.website) {
      // If the honeypot field is filled, silently succeed
      setStatus({
        submitted: true,
        submitting: false,
        error: null
      });
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: '',
        website: ''
      });
      return;
    }

    setStatus(prev => ({ ...prev, submitting: true, error: null }));

    try {
      const result = await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          from_name: formData.name,
          from_email: formData.email,
          subject: formData.subject,
          message: formData.message
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      if (result.text === 'OK') {
        setStatus({
          submitted: true,
          submitting: false,
          error: null
        });
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: '',
          website: ''
        });
        toast.success('Message sent successfully! We will get back to you soon.', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      setStatus({
        submitted: false,
        submitting: false,
        error: error.message
      });
      toast.error('Failed to send message. Please try again later.', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  return (
    <div className="page">
      <ToastContainer />
      <h1>Contact Us</h1>
      <p>Get in touch with our team for any questions or inquiries.</p>
      <div className="contact-content">
        <div className="contact-info">
          <h2>Contact Information</h2>
          <div className="info-item">
            <h3>Address</h3>
            <p>549 Paradise Road<br />
            York PA 17406<br />
            717-505-8513</p>
          </div>
          <div className="info-item">
            <h3>Email</h3>
            <p>bob.reed1@comcast.net</p>
          </div>
        </div>
        <div className="contact-form">
          <h2>Send us a Message</h2>
          {status.submitted ? (
            <div className="success-message">
              <h3>Thank you for your message!</h3>
              <p>We'll get back to you as soon as possible.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Your Name"
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="Your Email"
                />
              </div>
              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="Subject"
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Your Message"
                ></textarea>
              </div>
              {/* Honeypot field - hidden from users but visible to bots */}
              <div className="form-group honeypot">
                <label htmlFor="website">Website</label>
                <input
                  type="text"
                  id="website"
                  name="website"
                  value={formData.website}
                  onChange={handleChange}
                  placeholder="Your Website"
                  tabIndex="-1"
                  autoComplete="off"
                />
              </div>
              <button 
                type="submit" 
                disabled={status.submitting}
                className={status.submitting ? 'submitting' : ''}
              >
                {status.submitting ? 'Sending...' : 'Send Message'}
              </button>
              {status.error && (
                <div className="error-message">
                  <p>{status.error}</p>
                </div>
              )}
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default Contact; 